module.exports = "pegasus/assets/main-bg.png";